import React, {
  useCallback,
  useEffect,
  useState
} from "react"

import axios from "axios"
import Cookies from "js-cookie"

import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from "recharts"

const API = "https://food-backend-9733.onrender.com"

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalOrders: 0,
    totalUsers: 0,
    totalFoods: 0,
    activeFoods: 0,
    outOfStockFoods: 0,
    totalRevenue: 0
  })

  const [analytics, setAnalytics] = useState([])

  const token = JSON.parse(
    Cookies.get("logincrd") || "{}"
  )?.token

  const loadStats = useCallback(() => {
    axios.get(`${API}/admin/dashboard-stats`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      setStats(res.data)
    })
    .catch(err => {
      console.log(err)
    })
  }, [token])

  const loadAnalytics = useCallback(() => {
    axios.get(`${API}/admin/revenue-analytics`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(res => {
      setAnalytics(res.data)
    })
    .catch(err => {
      console.log(err)
    })
  }, [token])

  useEffect(() => {
    loadStats()
    loadAnalytics()
  }, [loadStats, loadAnalytics])

  const statCards = [
    {
      label: "Total Orders",
      value: stats.totalOrders,
      tone: "gold"
    },
    {
      label: "Total Users",
      value: stats.totalUsers,
      tone: "blue"
    },
    {
      label: "Total Foods",
      value: stats.totalFoods,
      tone: "green"
    },
    {
      label: "Active Foods",
      value: stats.activeFoods,
      tone: "green"
    },
    {
      label: "Out of Stock",
      value: stats.outOfStockFoods,
      tone: "red"
    },
    {
      label: "Revenue",
      value: `₹ ${stats.totalRevenue}`,
      tone: "dark"
    }
  ]

  return (
    <main className="admin-dashboard-page">
      <section className="admin-dashboard-hero">
        <div>
          <span>Admin Overview</span>
          <h1>Dashboard</h1>
          <p>
            Track orders, customers, stock visibility and revenue in one place.
          </p>
        </div>
      </section>

      <section className="admin-stats-grid">
        {statCards.map(card => (
          <div
            key={card.label}
            className={`admin-stat-card ${card.tone}`}
          >
            <p>{card.label}</p>
            <h2>{card.value}</h2>
          </div>
        ))}
      </section>

      <section className="admin-chart-card">
        <div className="admin-chart-head">
          <div>
            <h2>Revenue Analytics</h2>
            <p>Daily order count and revenue movement.</p>
          </div>
        </div>

        <div className="admin-chart-wrap">
          <ResponsiveContainer
            width="100%"
            height={360}
          >
            <LineChart data={analytics}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="#eadfce"
              />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="revenue"
                stroke="#8f241d"
                strokeWidth={3}
                dot={{
                  r: 4,
                  strokeWidth: 2
                }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </section>
    </main>
  )
}

export default AdminDashboard
